<div class="wrapper" style="overflow: hidden;">
  <!-- ---------------------------------header ------------------------------->

  <div class="header">
    <div class="container px-0">
      <div class="row no-gutter justify-content-center">
        <div class="col-md-7 text-center col-header">
          <div class="img-header">
            <a routerLink=""><img src="assets/img/logo.png" /></a>
          </div>
          <div class="text-header">
            <h3>KHOA </h3>
            <h3>QUẢN TRỊ KINH DOANH</h3>

          </div>
        </div>
        <div class="col-md-5">
          <div class="col-search">
            <div class="searchbar">
              <input required [(ngModel)]="titleSearch" name="titleSearch" id="titleSearch" class="search_input"
                type="text" placeholder="Tìm kiếm..." />

              <a (click)="onSearchClick(titleSearch)" class="search_icon"><i class="fas fa-search"></i></a>
            </div>
            <div class="textwidget">
              <a (click)="onVnClick()" routerLink=""
                class="lang lang-vi">Vietnamese</a>
              <a (click)="onEnClick()" routerLink="" class="lang lang-en">English</a>
              <!-- <a (click)="onFrClick()" routerLink="" class="lang lang-fr">France</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row bg-menu no-gutter justify-content-center">
      <div class="col-md-12 p-0 contain-main-menu">
        <div class="container">
          <!-- -----menu ------- -->
          <ul class="main-menu">
            <li *ngFor="let mainMenu of mainMenus">
              <a (click)="onMenuItemClick(mainMenu)">{{mainMenu?.title}}</a>
              <ul>
                <li *ngFor="let childMainMenu of mainMenu.childs">
                  <a (click)="onMenuItemClick(childMainMenu)" *ngIf="childMainMenu?.url==''">
                    <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                    {{childMainMenu?.title}}
                  </a>
                  <a *ngIf="childMainMenu?.url!='' && childMainMenu?.url!='https://hce.edu.vn?cat_id=46'"
                    target="_blank" href="{{childMainMenu?.url}}">
                    <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                    {{childMainMenu?.title}}
                  </a>
                  <a *ngIf="childMainMenu.url == 'https://hce.edu.vn?cat_id=46'" routerLink="/feedback"
                    skipLocationChange="true">
                    <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                    {{childMainMenu?.title}}
                  </a>
                </li>

              </ul>
            </li>
            <div class="clear"></div>
          </ul>
          <div class="logo-responsive">
            <i routerLink="/search" skipLocationChange="true" class="fa fa-search" aria-hidden="true"></i>
          </div>
          <i class="fa fa-bars icon-menu-responsive" aria-hidden="true"></i>

          <!-- responsive-menu -->
          <div class="search_list">
            <ul class="respon-menu">
              <li *ngFor="let mainMenu of mainMenus">
                <a (click)="onMenuItemClick(mainMenu)" class="menu-slide">{{
                  mainMenu?.title
                }}</a>
                <ul class="slideContent">
                  <li *ngFor="let childMainMenu of mainMenu?.childs">
                    <a (click)="onMenuItemClick(childMainMenu)" *ngIf="childMainMenu?.url == ''">
                      <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                      {{ childMainMenu?.title }}
                    </a>
                    <a *ngIf="childMainMenu?.url != ''" target="_blank" href="{{ childMainMenu?.url }}">
                      <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                      {{ childMainMenu?.title }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!-- ----- end menu ---- -->
        </div>
      </div>
    </div>
    <!-- background header -->
  </div>
  <!-- ---------------------------------- end header --------------------------- -->

  <router-outlet></router-outlet>

  <app-footer></app-footer>
  <button (click)="onToTopClick()" id="myBtn" title="Go to top">
    <i class="fa fa-fw" aria-hidden="true" title="Go to top"></i>
  </button>
</div>
